/**
 * @license lucide-react v0.378.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';
var ChevronUp = createLucideIcon("ChevronUp", [["path", {
  d: "m18 15-6-6-6 6",
  key: "153udz"
}]]);
export { ChevronUp as default };